
/**
 * InfiniteScroll
 */

class InfiniteScrollChat {

	private isCreated: boolean = false;

	private isLoadingFlag: boolean = false;

	private isUpStop: boolean = false;

	private isDownStop: boolean = false;

	private direction: string = 'down';

	private offset: number = 1;

	private currScrollTop: number;

	private $target: string;

	private callback: any;

	constructor( callback: any, $target: string ) {
		this.direction = 'down';
		this.callback = callback;
		this.currScrollTop = this.offset;
		this.$target = $target || '.comment-body';
	}

	public isLoading() {
		return this.isLoadingFlag;
	}

	public setLoadedComplete() {
		this.bind();
		this.isLoadingFlag = false;
	}

	public scrollBottom() {
		setTimeout( () => {
			jQuery( `${this.$target}` ).scrollTop( jQuery( `${this.$target}` )[ 0 ].scrollHeight - this.offset );
			this.isLoadingFlag = false;
			this.bind();
		}, 300 );
	}

	public loadedEnd( _scrollTop: any ) {
		setTimeout( () => {
			jQuery( `${this.$target}` ).scrollTop( _scrollTop || this.currScrollTop );
			this.isLoadingFlag = false;
			this.bind();
		}, 300 );
	}

	public setInitPos() {
		this.currScrollTop = jQuery( window ).scrollTop() || this.offset;
		jQuery( window ).scrollTop( this.currScrollTop );
	}

	public stop( dir: string ) {
		if ( dir === 'up' ) {
			this.isUpStop = true;
		} else {
			this.isDownStop = true;
		}
	}

	public bindScroll( evt: any ) {
		evt.preventDefault();

		const $this = jQuery( `${this.$target}` );

		if ( this.isLoadingFlag ) {
			return;
		}

		// top
		if ( $this.scrollTop() === 0 ) {

			if ( this.isUpStop ) {
				return;
			}

			this.isLoadingFlag = true;

			this.direction = 'up';

			// this.currScrollTop = $this.scrollTop() + this.offset;
			this.currScrollTop = 150;

			this.unbind();

			if ( this.callback ) {
				this.callback( this.direction );
			}

		// bottom
		} else if ( $this.scrollTop() + $this.innerHeight() >= $this[ 0 ].scrollHeight ) {

			this.isLoadingFlag = true;

			if ( this.isDownStop ) {
				return;
			}

			this.direction = 'down';

			this.currScrollTop = $this.scrollTop() - this.offset;

			this.unbind();

			if ( this.callback ) {
				this.callback( this.direction );
			}
		}
	}

	public unbind() {
		jQuery( `${this.$target}` ).off( 'scroll' );
	}

	public bind() {
		this.unbind();

		jQuery( `${this.$target}` ).on( 'scroll', ( evt ) => {
			this.bindScroll( evt );
		});
	}

	public start() {
		if ( !this.isCreated ) {
			this.isCreated = true;

			// jQuery( window ).scroll( ( evt ) => {
			jQuery( `${this.$target}` ).on( 'scroll', ( evt ) => {
				this.bindScroll( evt );
			});
		}
	}
}

export default InfiniteScrollChat;
